import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./professionlist.css";
import API from "../../../api";
import { Phone, MessageCircle, Mail } from "lucide-react";

export default function ProfessionList() {
  const { type } = useParams();
  const navigate = useNavigate();

  const [showConsult, setShowConsult] = useState(false);
const [consultUser, setConsultUser] = useState(null);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ===============================
     FETCH PROFESSIONAL DATA
  =============================== */
  useEffect(() => {
    setLoading(true);
    setError("");

    fetch(`/api/profession/${type}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setUsers(data.users);
        } else {
          setError("Failed to load profiles");
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Server error. Please try again.");
        setLoading(false);
      });
  }, [type]);

  /* ===============================
     OPEN CONSULT CHAT
  =============================== */
  const openContactProfessional = (professional) => {
  if (!localStorage.getItem("token")) {
    navigate("/");
    return;
  }

  setConsultUser(professional);
  setShowConsult(true);
};
  /* ===============================
     UI STATES
  =============================== */
  if (loading) {
    return (
      <div className="profession-page">
        <p className="status-text">Loading {type} profiles…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="profession-page">
        <p className="status-text error">{error}</p>
      </div>
    );
  }

  if (!users.length) {
    return (
      <div className="profession-page">
        <p className="status-text">No {type}s found</p>
      </div>
    );
  }

  /* ===============================
     MAIN RENDER
  =============================== */
  return (
    <div className="profession-page">
      <div className="profession-header">
        <h2 className="profession-title">
          {type.charAt(0).toUpperCase() + type.slice(1)} Professionals
        </h2>
        <p className="profession-subtitle">
          Verified professionals available for consultation
        </p>
      </div>

      <div className="profession-grid">
        {users.map((u) => (
          <div key={u._id} className="profession-card"
            onClick={() => {
  if (!localStorage.getItem("token")) {
    navigate("/login");
    return;
  }

  navigate(`/profile/${u._id}`);
}}
          >
            {/* Card Header */}
            <div className="profession-card-header">
              <div className="profession-avatar">
                {u.name?.charAt(0)}
              </div>

              <div className="profession-basic">
                <div className="profession-name">{u.name}</div>
                <div className="profession-role">{u.profession}</div>
              </div>
            </div>

            {/* Card Body */}
            <div className="profession-body">
              <div className="profession-info">
                <span className="verified-badge">✅ Verified</span>

                <span>Experience</span>
                <strong>{u.experienceYears} years</strong>
              </div>

              {u.skills?.length > 0 && (
                <div className="profession-skills">
                  {u.skills.map((skill, i) => (
                    <span key={i} className="skill-chip">
                      {skill}
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* Card Footer */}
            <div className="profession-footer">
            <button
  className="consult-btn"
  onClick={(e) => {
  e.stopPropagation();
  openContactProfessional(u);
}}
>
  Consult
</button>



            </div>
            
            
          </div>
        ))}
      </div>

      {showConsult && (
  <div
    className="customer-sheet-overlay"
    onClick={() => setShowConsult(false)}
  >
    <div
      className="customer-sheet"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="sheet-handle" />

      <h3 className="sheet-title">
        Contact Professional
      </h3>

      <p className="sheet-subtitle">
        Choose how you'd like to connect.
      </p>

      {consultUser?.phone && (
        <>
          <button
            className="sheet-btn primary"
            onClick={() => {
              window.location.href = `tel:${consultUser.phone}`;
              setShowConsult(false);
            }}
          >
            <Phone size={18} />
            <span>Call</span>
          </button>

          <button
            className="sheet-btn primary"
            onClick={() => {
              const text = encodeURIComponent(
                `Hello ${consultUser.name},

I found your profile on Civilink and would like to discuss my construction requirements.`
              );

              window.open(
                `https://wa.me/91${consultUser.phone}?text=${text}`,
                "_blank"
              );

              setShowConsult(false);
            }}
          >
            <MessageCircle size={18} />
            <span>WhatsApp</span>
          </button>
        </>
      )}

      {consultUser?.email && (
        <button
          className="sheet-btn primary"
          onClick={() => {
            window.location.href = `mailto:${consultUser.email}?subject=Construction Inquiry from Civilink`;
            setShowConsult(false);
          }}
        >
          <Mail size={18} />
          <span>Email</span>
        </button>
      )}

      {!consultUser?.phone && !consultUser?.email && (
        <div className="contact-unavailable">
          Contact information not available.
        </div>
      )}

      <button
        className="sheet-btn outline"
        onClick={() => setShowConsult(false)}
      >
        Close
      </button>
    </div>
  </div>
)}
    </div>
  );
}
